import { Box, Typography, Alert, Snackbar } from "@mui/material";
import { colors } from "../../theme/colors";

export const authTextFieldSx = {
  "& .MuiOutlinedInput-root": {
    backgroundColor: colors.white,
    borderRadius: "6px",
    "& fieldset": {
      borderColor: "transparent",
    },
    "&:hover fieldset": {
      borderColor: "transparent",
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.gold,
      borderWidth: "1px",
    },
    "&.Mui-error fieldset": {
      borderColor: colors.error,
    },
  },
  "& .MuiOutlinedInput-input": {
    py: 1.5,
    px: 1.75,
    color: colors.text,
    fontSize: "0.95rem",
    "&::placeholder": {
      color: colors.placeholder,
      opacity: 1,
    },
  },
  "& .MuiFormHelperText-root": {
    ml: 0.5,
  },
};

export const authSubmitButtonSx = {
  mt: 1.5,
  height: 48,
  bgcolor: colors.gold,
  color: colors.black,
  fontWeight: 700,
  fontSize: "0.9rem",
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  borderRadius: "6px",
  boxShadow: "none",
  "&:hover": {
    bgcolor: colors.goldHover,
    boxShadow: "none",
  },
  "&.Mui-disabled": {
    bgcolor: colors.gold,
    color: colors.black,
    opacity: 0.7,
  },
};

export default function AuthPage({
  subtitle,
  children,
  notification,
  onCloseNotification,
}) {
  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        bgcolor: colors.black,
        color: colors.white,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        py: 4,
        boxSizing: "border-box",
        overflow: "auto",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 360,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          flex: 1,
          justifyContent: "center",
        }}
      >
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/assets/logo_divider.png`}
          alt="QUE"
          sx={{
            width: "100%",
            maxWidth: 260,
            height: "auto",
            display: "block",
            mb: 0.25,
          }}
        />

        <Typography
          sx={{
            color: colors.gold,
            fontSize: "0.7rem",
            letterSpacing: "0.35em",
            fontWeight: 500,
            textTransform: "uppercase",
            mb: 5,
          }}
        >
          The Salon Platform
        </Typography>

        {subtitle ? (
          <Typography
            sx={{
              color: colors.muted,
              fontSize: "0.875rem",
              mb: 3,
              textAlign: "center",
            }}
          >
            {subtitle}
          </Typography>
        ) : null}

        {children}
      </Box>

      <Typography
        sx={{
          color: colors.muted,
          fontSize: "0.75rem",
          flexShrink: 0,
          pb: 1,
        }}
      >
        By Jon David Tech
      </Typography>

      {notification ? (
        <Snackbar
          open={notification.open}
          autoHideDuration={notification.duration}
          onClose={onCloseNotification}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            onClose={onCloseNotification}
            severity={notification.severity}
            sx={{ width: "100%" }}
          >
            {notification.message}
          </Alert>
        </Snackbar>
      ) : null}
    </Box>
  );
}
